export default function MerchantBankInfo({ order, banks }) {
  if (!order?.merchant_bank?.cuenta_receptora) return null;
  const mb = order.merchant_bank;
  const bankName = banks.find((b) => b.codigo === mb.banco_receptor)?.nombre || `Banco ${mb.banco_receptor}`;

  return (
    <div className="bg-gray-50 border-2 border-gray-200 rounded-xl p-5 space-y-3" data-testid="merchant-bank-info">
      <p className="text-sm font-bold text-gray-800 mb-3">Datos de la cuenta destino:</p>
      <div className="grid grid-cols-2 gap-3 text-sm">
        {mb.company_name && (
          <div>
            <p className="text-xs text-gray-500">Beneficiario</p>
            <p className="font-semibold text-gray-800">{mb.company_name}</p>
          </div>
        )}
        {mb.rif && (
          <div>
            <p className="text-xs text-gray-500">RIF</p>
            <p className="font-semibold text-gray-800">{mb.rif}</p>
          </div>
        )}
        <div className="col-span-2">
          <p className="text-xs text-gray-500">Cuenta</p>
          <p className="font-mono font-bold text-gray-800 text-base tracking-wider">{mb.cuenta_receptora}</p>
        </div>
        {mb.banco_receptor && (
          <div>
            <p className="text-xs text-gray-500">Banco</p>
            <p className="font-semibold text-gray-800">{bankName}</p>
          </div>
        )}
      </div>
      <div className="mt-3 pt-3 border-t border-gray-200">
        <p className="text-xs text-gray-500">Monto exacto a transferir</p>
        <p className="text-2xl font-bold" style={{ color: '#003594' }}>
          {order.currency} {order.amount.toFixed(2)}
        </p>
      </div>
    </div>
  );
}
